module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    class: ("" + (_vm.isEditMode ? 'no-boxshadow' : '')),
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('div', {
    class: ("" + (_vm.isCreateMode ? 'container container--fluid' : ''))
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "id": "rate-card-form",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    class: ("content xs12 " + (_vm.isCreateMode ? 'md7' : 'md12'))
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-right pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "100px",
      "float": "right"
    },
    attrs: {
      "item-text": "title",
      "item-value": "value",
      "items": _vm.langOptions,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeLang()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('span', {
          class: ("fi " + (item.icon))
        }), _vm._v(" " + _vm._s(item.title))])]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('span', {
          class: ("fi " + (item.icon))
        }), _vm._v(" " + _vm._s(item.title))])]
      }
    }]),
    model: {
      value: (_vm.selectedLang),
      callback: function($$v) {
        _vm.selectedLang = $$v
      },
      expression: "selectedLang"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isCreateMode) ? _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "KOBE Logo"
    }
  })])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.formConfig.title))])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "px-5 clearfix",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('name')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "textbox",
      "outlined": "",
      "required": "",
      "hide-details": "",
      "error-messages": _vm.$v.rateCardData.name.$error && "Name is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.name.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.name),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "name", $$v)
      },
      expression: "rateCardData.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('email')) + "  "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "email",
      "outlined": "",
      "required": "",
      "hide-details": "",
      "error-messages": _vm.$v.rateCardData.email.$error && (!_vm.$v.rateCardData.email.required ? 'Email is required.' : !_vm.$v.rateCardData.email.email ? 'Please enter a valid email address.' : '')
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.rateCardData.email),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "email", $$v)
      },
      expression: "rateCardData.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('dateOfBirth')))]), _vm._v(" "), _c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.rateCardDOB,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.rateCardDOB = $event
      },
      "update:return-value": function($event) {
        _vm.rateCardDOB = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "append-icon": "event",
            "hide-details": "",
            "outlined": "",
            "readonly": ""
          },
          model: {
            value: (_vm.rateCardData.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData, "dateOfBirth", $$v)
            },
            expression: "rateCardData.dateOfBirth"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.DOBDateCal),
      callback: function($$v) {
        _vm.DOBDateCal = $$v
      },
      expression: "DOBDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "id": "rate-card-date-picker",
      "type": "month",
      "max": _vm.minBirthDate,
      "show-current": _vm.minBirthDate
    },
    model: {
      value: (_vm.rateCardData.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "dateOfBirth", $$v)
      },
      expression: "rateCardData.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.DOBDateCal = false
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.changeDate
    }
  }, [_vm._v("\n                            OK\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('country')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.countries,
      "hide-details": "",
      "outlined": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.country.$error && "Country is required."
    },
    on: {
      "change": function($event) {
        return _vm.changeCountry()
      },
      "input": function($event) {
        return _vm.$v.rateCardData.country.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.country),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "country", $$v)
      },
      expression: "rateCardData.country"
    }
  })], 1), _vm._v(" "), (_vm.rateCardData.country === 'Singapore' || _vm.rateCardData.country === 'Malaysia') ? _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('ethnicity')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.ethnicityOptions,
      "hide-details": "",
      "outlined": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.ethnicity.$error && "Ethnicity is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.ethnicity.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "ethnicity", $$v)
      },
      expression: "rateCardData.ethnicity"
    }
  }), _vm._v(" "), (_vm.rateCardData.ethnicity === 'Others') ? _c('v-text-field', {
    staticClass: "pr-1 mt-2",
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.otherEth),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "otherEth", $$v)
      },
      expression: "rateCardData.otherEth"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('gender')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "purple-input",
    attrs: {
      "items": _vm.genderOptions,
      "type": "textbox",
      "outlined": "",
      "hide-details": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.gender.$error && "Gender is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.gender.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.gender),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "gender", $$v)
      },
      expression: "rateCardData.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('ContactNo')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "12px",
      "padding-left": "15px"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "100px",
      "border-radius": "5px 0 0 5px"
    },
    attrs: {
      "items": _vm.countryCodeOptions,
      "outlined": ""
    },
    model: {
      value: (_vm.countryCode),
      callback: function($$v) {
        _vm.countryCode = $$v
      },
      expression: "countryCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    staticStyle: {
      "border-radius": "0 5px 5px 0"
    },
    attrs: {
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.contactNo),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "contactNo", $$v)
      },
      expression: "rateCardData.contactNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('occupation')))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.occupation),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "occupation", $$v)
      },
      expression: "rateCardData.occupation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.formConfig.sections), function(section, index) {
    return _c('v-col', {
      key: index,
      class: section.class ? section.class : 'xs12 md6',
      style: (section.style || '')
    }, [_c('div', _vm._l((section.fields), function(field, index) {
      return _c('v-col', {
        key: index,
        staticClass: "align-center",
        class: field.class ? field.class : 'xs12 md6',
        style: (field.style || '')
      }, [(field.label !== '') ? _c('p', {
        class: ("h4 font-weight-bold mb-2 " + (field.labelClass || '')),
        staticStyle: {
          "min-height": "39.59px"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.getLang(field.name)) + " \n                          "), (field.required) ? _c('span', {
        staticClass: "red--text"
      }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (field.type === 'number') ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [(_vm.isEditMode && field.name === 'igStory') ? _c('div', [_c('p', {
        staticClass: "rate-label-title"
      }, [_vm._v("Ordinary")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-row"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.rateCardData.ordinaryRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.ordinaryRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "rateCardData.ordinaryRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData.ordinaryRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.ordinaryRates, field.name, _vm._n($$v))
          },
          expression: "rateCardData.ordinaryRates[field.name]"
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (field.type === 'number' && _vm.isEditMode) ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [(field.name === 'igStory') ? _c('div', [_c('p', {
        staticClass: "rate-label-title pl-3"
      }, [_vm._v("Preferential")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-row pl-3"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.rateCardData.preferentialRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.preferentialRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "rateCardData.preferentialRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData.preferentialRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.preferentialRates, field.name, _vm._n($$v))
          },
          expression: "rateCardData.preferentialRates[field.name]"
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && (field.name !== 'instagramHandle' && field.name !== 'tiktokHandle')) ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && (field.name === 'instagramHandle' || field.name === 'tiktokHandle')) ? _c('v-text-field', {
        staticClass: "purple-input social-handle-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "prefix": "@",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'normalNumber') ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "number",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        on: {
          "keypress": _vm.onlyForNumber
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
        attrs: {
          "filled": "",
          "auto-grow": "",
          "hint": field.hint || '',
          "persistent-hint": field.hint ? true : false,
          "placeholder": field.placeholder,
          "required": "",
          "hide-details": "auto"
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('custom-file-upload', {
        attrs: {
          "refresh": _vm.fileUploadRefresh,
          "multiple": true
        },
        on: {
          "setMedias": _vm.updatePricingDecks
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'multiple') ? _c('div', [_c('div', {
        staticClass: "social-platform-list"
      }, [_vm._l((_vm.rateCardData[field.name]), function(multipleOne, pIndex) {
        return _c('div', {
          key: pIndex,
          staticClass: "social-platform-entry"
        }, [_c('div', {
          staticClass: "social-platform-main"
        }, [_c('v-select', {
          staticClass: "social-platform-select",
          attrs: {
            "items": field.options[0].options,
            "item-value": "value",
            "item-text": "label",
            "hide-details": "",
            "label": field.options[0].label,
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].platform),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "platform", $$v)
            },
            expression: "rateCardData[field.name][pIndex].platform"
          }
        }), _vm._v(" "), _c('v-text-field', {
          staticClass: "social-platform-url",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.options[1].placeholder
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].url),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "url", $$v)
            },
            expression: "rateCardData[field.name][pIndex].url"
          }
        }), _vm._v(" "), _c('v-btn', {
          staticClass: "social-platform-delete",
          attrs: {
            "icon": "",
            "small": "",
            "aria-label": "Remove platform"
          },
          on: {
            "click": function($event) {
              _vm.rateCardData[field.name].splice(pIndex, 1)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("mdi-delete-forever")])], 1)], 1), _vm._v(" "), (_vm.rateCardData[field.name][pIndex][field.child.parentName] === 'others') ? _c('v-text-field', {
          staticClass: "social-platform-other",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.child.placeholder
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex][field.child.name]),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], field.child.name, $$v)
            },
            expression: "rateCardData[field.name][pIndex][field.child.name]"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "social-platform-rate"
        }, [_c('v-select', {
          staticClass: "currency-select-multiple",
          attrs: {
            "items": _vm.currenyOptions,
            "hide-details": "",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].rateCurrency),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "rateCurrency", _vm._n($$v))
            },
            expression: "rateCardData[field.name][pIndex].rateCurrency"
          }
        }), _vm._v(" "), _c('v-text-field', {
          staticClass: "multiple-rate",
          attrs: {
            "type": "number",
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": "Rate"
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].rate),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "rate", _vm._n($$v))
            },
            expression: "rateCardData[field.name][pIndex].rate"
          }
        })], 1)], 1)
      }), _vm._v(" "), _c('div', {
        staticClass: "text-right"
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            return _vm.addPlatform(field.name)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                              ")], 1)], 1)], 2)]) : _vm._e()], 1)
    }), 1)])
  }), 1), _vm._v(" "), (!_vm.rateCardData.instagramHandle && !_vm.rateCardData.tiktokHandle) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0 px-5 mx-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.getLang('enterIgTikTok')) + " *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "px-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('preferredCampaigns')))]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary white--text",
      "column": "",
      "required": ""
    },
    model: {
      value: (_vm.rateCardData.keywords),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "keywords", $$v)
      },
      expression: "rateCardData.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }), 1), _vm._v(" "), (_vm.rateCardData.keywords !== null && !_vm.rateCardData.keywords.length) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.getLang('preferredCampaigns')))]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('bestRepresent')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "required": "",
      "hide-details": "auto",
      "error-messages": _vm.$v.rateCardData.aboutYou.$error && "This field is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.aboutYou.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.aboutYou),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "aboutYou", $$v)
      },
      expression: "rateCardData.aboutYou"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('giftBrand')))]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "color": "secondary"
    },
    model: {
      value: (_vm.rateCardData.giftBrand),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "giftBrand", $$v)
      },
      expression: "rateCardData.giftBrand"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "Yes",
      "label": _vm.getLang('yes'),
      "color": "secondary"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "No",
      "label": _vm.getLang('noPaidCampaign'),
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-space-between align-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.$route.query.cc) ? _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Referred By:")]), _vm._v(" " + _vm._s(_vm.$route.query.cc) + "\n                ")]) : _c('div'), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('rate-card-terms-modal', {
    attrs: {
      "value": _vm.showAgreementModal,
      "selectedLang": _vm.selectedLang
    },
    on: {
      "termsAggrement": _vm.confirmSave
    },
    model: {
      value: (_vm.showAgreementModal),
      callback: function($$v) {
        _vm.showAgreementModal = $$v
      },
      expression: "showAgreementModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3556129a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/JoinCommunity/Form.vue
// module id = 2075
// module chunks = 0